
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    member: {
      type: Object,
      required: true,
    },
  },

  computed: {
    memberName() {
      return `${this.member.given_name} ${this.member.family_name}`.trim()
    },
  },
}
